<div class="relative">
  <button
    class="text-green-600 hover:text-green-800 hover:scale-110 transition-transform cursor-pointer"
    type="button"
    (click)="isOpen = true"
    appAgentAction
    agent="export-nw-number-popover-open"
    businessObject="nwNumber"
    [businessId]="$safeNavigationMigration(nwNumber?.id)"
    action="open"
  >
    <app-download-icon></app-download-icon>
  </button>
  <div
    role="tooltip"
    class="absolute z-10 right-4 top-6 inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-md w-72"
    [class.invisible]="!isOpen"
    [class.opacity-0]="!isOpen"
  >
    <div class="p-3 space-y-2">
      <div class="flex justify-between">
        <h3 class="font-bold text-gray-800">Export</h3>
        <app-close-icon
          class="cursor-pointer hover:scale-110 transition-transform"
          (click)="isOpen = false"
          appAgentAction
          agent="export-nw-number-popover-close"
          businessObject="nwNumber"
          [businessId]="$safeNavigationMigration(nwNumber?.id)"
          action="close"
        ></app-close-icon>
      </div>
      <button
        *appIfPolicySatisfied="policy.canImport"
        (click)="
          exportClicked.emit({ nwNumber: nwNumber!, exportType: exportType.ExportTrDocumentation }); isOpen = false
        "
        type="button"
        class="text-teal-400 disabled:text-gray-400 hover:text-teal-600 cursor-pointer hover:scale-105 hover:bg-orange-100 p-0.5 rounded-md"
        appAgentAction
        agent="export-nw-number-popover-export-tr-documentation"
        businessObject="nwNumber"
        [businessId]="$safeNavigationMigration(nwNumber?.id)"
        action="export"
      >
        <div class="flex items-start gap-x-4">
          <app-import-icon class="font-medium"></app-import-icon>
          <p class="text-xs text-gray-500 text-start">Export of TR documentation fields</p>
        </div>
      </button>

      <div class="border-b border-gray-300"></div>

      <button
        *appIfPolicySatisfied="policy.canPublishSyncEvents"
        (click)="publishEventsClicked.emit({ nwNumber: nwNumber! }); isOpen = false"
        type="button"
        class="text-blue-500 disabled:text-gray-400 hover:text-blue-700 cursor-pointer hover:scale-105 hover:bg-orange-100 p-0.5 rounded-md"
        appAgentAction
        agent="export-nw-number-popover-publish-service-bus-events"
        businessObject="nwNumber"
        [businessId]="$safeNavigationMigration(nwNumber?.id)"
        action="export"
      >
        <div class="flex items-start gap-x-4">
          <app-cloud-arrow-up-icon></app-cloud-arrow-up-icon>
          <p class="text-xs text-gray-500 text-start">Publish Error Code synchronisation events for AMAiQ</p>
        </div>
      </button>
    </div>
  </div>
</div>
